import { TweenMax, Power4 } from 'gsap';

class Share {
  constructor(view = null) {
    this.share = (view ? view.querySelector('.js-share') : document.querySelector('.js-share'));
    this.button = this.share.querySelector('.js-btn-share');
    this.items = [...this.share.querySelectorAll('.js-btn-item')];

    this.data = {
      total: this.items.length,
      itemHeight: this.items[0].offsetHeight,
      margin: 10
    };

    this.state = {
      open: false
    };
  }

  toggle = () => {
    [...this.items].forEach((item, index) => {
      if (!this.state.open) {
        TweenMax.fromTo(
          item,
          0.3,
          { y: 0 },
          { y: (this.data.itemHeight + this.data.margin) * (index + 1) * -1, ease: Power4.easeOut }
        );
      }

      if (this.state.open) {
        TweenMax.to(
          item,
          0.3,
          { y: 0, ease: Power4.easeOut }
        );
      }
    });

    this.state.open = !this.state.open;
  }

  sharePage = (e) => {
    const url = window.location.href;
    const type = e.target.getAttribute('data-type');

    let shareLink;

    if (type === 'facebook') shareLink = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    if (type === 'twitter') shareLink = `https://twitter.com/intent/tweet?url=${url}`;

    window.open(shareLink, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
  }

  init = () => {
    this.button.addEventListener('click', this.toggle, { passive: true });

    [...this.items].forEach((item) => item.addEventListener('click', this.sharePage, { passive: true }));
  }

  destroy = () => {
    this.button.removeEventListener('click', this.toggle);

    [...this.items].forEach((item) => item.removeEventListener('click', this.sharePage));
  }
}

export default Share;
